export const keyEventsStateSelector = (state: any) => state.keyEvents;
export const videoInterviewsStateSelector = (state:any) => state.videoInterviews